// Debug utility to check localStorage and sessionStorage
export const debugStorage = {
  checkAllStorage: function() {
  },

  monitorStorageChanges: function() {
    // Monitor localStorage changes
    const originalSetItem = Storage.prototype.setItem;
    const originalRemoveItem = Storage.prototype.removeItem;
    const originalClear = Storage.prototype.clear;

    Storage.prototype.setItem = function(key, value) {
      originalSetItem.apply(this, arguments);
    };

    Storage.prototype.removeItem = function(key) {
      originalRemoveItem.apply(this, arguments);
    };

    Storage.prototype.clear = function() {
      originalClear.apply(this, arguments);
    };

  },

  testTokenStorage: function() {
    // Test localStorage
    localStorage.setItem('test_token', 'test_value_local');
    const localTest = localStorage.getItem('test_token');
    localStorage.removeItem('test_token');
    
    // Test sessionStorage
    sessionStorage.setItem('test_token', 'test_value_session');
    const sessionTest = sessionStorage.getItem('test_token');
    sessionStorage.removeItem('test_token');
  }
};

// Auto-expose to window for easy console access
if (typeof window !== 'undefined') {
  window.debugStorage = debugStorage;
}